import memoize from "lodash.memoize";
import { stripUnit } from "../";
import { ONE_PX_IN_REM } from "../../constants";

const getValueAndUnit = (value: string) => stripUnit(value, true);
type MinusOnePx = (value: string | number, convertToPx?: boolean) => string;

export const minusOnePx: MinusOnePx = memoize((value, convertToPx) => {
  const [dimension, unit] = getValueAndUnit(value);
  switch (unit) {
    case "em":
    case "rem":
      return `${
        convertToPx ? dimension / ONE_PX_IN_REM - 1 : dimension - ONE_PX_IN_REM
      }${convertToPx ? "px" : unit}`;
    case "px":
      return `${dimension - 1}px`;
    default:
      return value;
  }
});
